module.exports = __webpack_public_path__ + "static/img/INF.2aaffa54.png";